let timeout = null

export const debounce = (callback, time = 500) => {
  clearTimeout(timeout)

  timeout = setTimeout(() => {
    callback()
  }, time)
}
